import React, { useMemo, useState } from 'react';
import { Sparkles, RotateCcw, X } from 'lucide-react';
import { CONVERSATION_STARTERS } from '../lib/starters';

const PICK_COUNT = 3;

const pickRandom = (n, exclude = new Set()) => {
  const pool = CONVERSATION_STARTERS.filter((_, i) => !exclude.has(i));
  const indices = [];
  while (indices.length < n && indices.length < pool.length) {
    const idx = Math.floor(Math.random() * pool.length);
    if (!indices.includes(idx)) indices.push(idx);
  }
  return indices.map((i) => pool[i]);
};

const ConversationStarters = ({ onPick, visible, onDismiss }) => {
  const [seed, setSeed] = useState(0);
  const items = useMemo(() => pickRandom(PICK_COUNT), [seed]);
  if (!visible) return null;

  return (
    <div className="px-4 pt-3 pb-1" data-testid="conversation-starters">
      <div className="flex items-center justify-between mb-1.5">
        <div className="flex items-center gap-1.5 text-xs uppercase tracking-wider font-bold text-fnl-pink">
          <Sparkles className="w-3.5 h-3.5" />
          Conversation starters
        </div>
        <div className="flex items-center gap-1">
          <button
            type="button"
            onClick={() => setSeed((s) => s + 1)}
            className="text-purple-300 hover:text-white text-xs flex items-center gap-1 px-2 py-1 rounded"
            data-testid="starters-refresh"
            aria-label="New suggestions"
          >
            <RotateCcw className="w-3 h-3" />New
          </button>
          <button
            type="button"
            onClick={onDismiss}
            className="text-purple-300 hover:text-white px-2 py-1 rounded"
            data-testid="starters-dismiss"
            aria-label="Hide starters"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1 no-scrollbar">
        {items.map((text, i) => (
          <button
            key={`${seed}-${i}`}
            type="button"
            onClick={() => onPick(text)}
            className="shrink-0 px-3 py-1.5 rounded-full bg-fnl-purple-light/50 border border-purple-700/60 text-purple-100 text-xs hover:bg-fnl-pink/20 hover:border-fnl-pink/60 hover:text-white transition"
            data-testid={`starter-chip-${i}`}
          >
            {text}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ConversationStarters;
